import {
  Box,
  Grid,
  GridItem,
  Button,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Text,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Flex,
  FormLabel
} from '@chakra-ui/react'
import { FC } from 'react'
import { FaSave } from 'react-icons/fa'
import Select from 'react-select'

import useReabTimeline from '@hook/parametrization/use-reab-timeline'

import LayoutLoader from '@component/Layout/Loader'
import LayoutTools from '@component/Layout/Tools'
import SpecialSchedule from '@view/SchedulePage'
import SpecialScheduleV2 from '@view/SchedulePageSpecial'

const ParametrizationFerragemReab: FC = () => {
  const {
    ferragemTimelineDefault,
    ferragemTimelineSpecial,
    activeTimelineFerragem,
    createData,
    paramsDatesFerragem,
    handleParamsDateFerragem,
    handleTimelineFerragemSpecialNew,
    handleTimelineActiveFerragem,
    handleTimelineFerragemNormalyNew,
    loading,
    data,
    filename,
    filters,
    fetching,
    query,
    actions,
    setFilename,
    selectedLojaId,
    getDistinctLojas,
    handleLojaFilter,
    originalData
  } = useReabTimeline()

  // Debug: Log quando os dados dos calendários mudam
  const { isOpen, onOpen, onClose } = useDisclosure()

  // useEffect(() => {
  //   getCenters()

  //   data?.length === 0 && getData()
  //   getFilters({})

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])
  return (
    <Box>
      <LayoutTools
        title={filename}
        filters={filters}
        actions={actions}
        query={query}
        onTitleChange={setFilename}
        isDisabled={loading || fetching || data.length === 0}
      />

      {/* Filtro de Loja */}
      <Box px={4} py={2} borderBottom="1px" borderColor="gray.200">
        <Flex align="center" gap={4}>
          <FormLabel mb={0} minW="80px" fontSize="sm" fontWeight="medium">
            Filtrar por Loja:
          </FormLabel>
          <Box minW="250px">
            <Select
              value={
                selectedLojaId
                  ? {
                      value: selectedLojaId,
                      label: selectedLojaId
                        ? `Loja ${selectedLojaId}`
                        : 'Todas as lojas'
                    }
                  : { value: '', label: 'Todas as lojas' }
              }
              onChange={(selected: any) =>
                handleLojaFilter(selected?.value || '')
              }
              options={getDistinctLojas(originalData)}
              isDisabled={loading || originalData.length === 0}
              placeholder="Selecione uma loja..."
              isClearable
              styles={{
                control: provided => ({
                  ...provided,
                  minHeight: '32px',
                  fontSize: '14px'
                }),
                menu: provided => ({
                  ...provided,
                  zIndex: 9999
                })
              }}
            />
          </Box>
        </Flex>
      </Box>

      {loading ? (
        <LayoutLoader
          title="Recuperando informações..."
          message="Aguarde enquanto buscamos os dados no banco de dados"
        />
      ) : (
        <Box>
          <Grid templateColumns="repeat(2, 1fr)" gap={6}>
            <GridItem w="100%">
              <SpecialSchedule
                key={`ferragem-default-${selectedLojaId}-${JSON.stringify(
                  ferragemTimelineDefault
                )}`}
                initialSchedule={ferragemTimelineDefault}
                activeTimeline={activeTimelineFerragem}
                setActiveTimeLine={handleTimelineActiveFerragem}
                onScheduleChange={handleTimelineFerragemNormalyNew}
                setorId={2}
              />
            </GridItem>
            <GridItem w="100%">
              {' '}
              <SpecialScheduleV2
                key={`ferragem-special-${selectedLojaId}-${JSON.stringify(
                  ferragemTimelineSpecial
                )}`}
                paramsDate={paramsDatesFerragem}
                initialSchedule={ferragemTimelineSpecial}
                activeTimeline={activeTimelineFerragem}
                onScheduleChange={handleTimelineFerragemSpecialNew}
                updateParamsDate={handleParamsDateFerragem}
                setActiveTimeLine={handleTimelineActiveFerragem}
                setorId={2}
              />{' '}
            </GridItem>
          </Grid>
        </Box>
      )}

      {/* Botão de salvar fixo no canto inferior esquerdo */}

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent bg="white">
          <ModalHeader
            paddingTop={2}
            paddingBottom={2}
            paddingLeft={4}
            paddingRight={4}
            textColor={'gray.200'}
            background={'#1d5840'}
            borderTopLeftRadius={5}
            borderTopRightRadius={5}
            borderBottom="3px solid #ECC94B"
          >
            Configuração Reab
          </ModalHeader>
          <ModalCloseButton
            top={1}
            right={1.5}
            textColor={'gray.200'}
            size="lg"
          />
          <ModalBody>
            <Text>Desejar confirmar as configurações realizadas?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="green" onClick={createData}>
              Salvar
            </Button>
            <Button colorScheme="red" onClick={onClose} ml={3}>
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Button
        position="fixed"
        bottom="20px"
        bg="green.600"
        color="white"
        right="20px"
        onClick={onOpen}
        size="lg"
        leftIcon={<FaSave />}
        _hover={{ bg: 'green.600' }}
      >
        Salvar
      </Button>
    </Box>
  )
}

export default ParametrizationFerragemReab
